export default {
  getUserId: function (state, getters, rootState) {
    let ui = { ...(((state.wechatUserInfo || {}).value || {}).binding || {}) };
    return ui.user_id||null;
  },
  function_name(state, getters, rootState) {
    return 'value'
  },
  getVipNo: function (state) {
    return (state.userInfo) ? state.userInfo.VipNo : null;
  },
  getAccessToken: function (state) {
    return (state.userInfo) ? state.userToken : null;
  },
  getCustomerType:function(state){
    let ui = { ...(((state.wechatUserInfo || {}).value || {}).binding || {}) };
    return (ui.customer_type||'RT').toUpperCase();
  },
  // bogo_switch: function (state) {
  //   if (state.sysConfig && state.sysConfig.value && state.sysConfig.value.bogo_switch[0] == '1') {
  //     return true
  //   }
  //   return false;
  // },
  bogo_switch_tip: function (state) {
    // if (state.sysConfig && state.sysConfig.value && state.sysConfig.value.bogo_switch[0] == '1') {
    //   return state.sysConfig.value.bogo_switch_tip
    // }
    return null
  },
  // useCDN:function(state) {
  //   if (state.sysConfig && state.sysConfig.value && state.sysConfig.value.bogo_switch && state.sysConfig.value.bogo_switch[1] == '1') {
  //     return true
  //   }
  //   return false
  // },
  // newActivity:function(state) {
  //   if (state.sysConfig && state.sysConfig.value && state.sysConfig.value.bogo_switch && state.sysConfig.value.bogo_switch[3] == '1') {
  //     return true
  //   }
  //   return false
  // },
  loadCart: state=>{
    let status=state.trace["cartInfo"]
    return status

  },
  nowTime:function(state){
    if (state.sysConfig && state.sysConfig.value) {
        return state.sysConfig.value.now_time
    }
    else{
      return null
    }
  }
}
